// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.notifications.RentalManagerUserNotificationsV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserNotificationsV2WebApiHandler_delete,
  RentalManagerUserNotificationsV2WebApiHandler_markAsRead,
  RentalManagerUserNotificationsV2WebApiHandler_tracking,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserNotificationsDeleteV2RequestDto,
  UserNotificationsDeleteV2WebDto,
  UserNotificationsMarkAsReadV2RequestDto,
  UserNotificationsMarkAsReadV2WebDto,
  UserNotificationsTrackingV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserNotificationsV2WebApiHandler_delete_Args {
  postData: UserNotificationsDeleteV2RequestDto;
}

export type RentalManagerUserNotificationsV2WebApiHandler_delete_Options = UseMutationOptions<
  UserNotificationsDeleteV2WebDto,
  unknown,
  RentalManagerUserNotificationsV2WebApiHandler_delete_Args
>;

/**
 * Delete a notification
 */
export const useRentalManagerUserNotificationsV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserNotificationsV2WebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserNotificationsV2WebApiHandler_delete_Args) =>
      RentalManagerUserNotificationsV2WebApiHandler_delete(args.postData, httpClient),
  });
};

export interface RentalManagerUserNotificationsV2WebApiHandler_markAsRead_Args {
  postData: UserNotificationsMarkAsReadV2RequestDto;
}

export type RentalManagerUserNotificationsV2WebApiHandler_markAsRead_Options = UseMutationOptions<
  UserNotificationsMarkAsReadV2WebDto,
  unknown,
  RentalManagerUserNotificationsV2WebApiHandler_markAsRead_Args
>;

/**
 * Mark a notification as read
 */
export const useRentalManagerUserNotificationsV2WebApiHandler_markAsRead = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserNotificationsV2WebApiHandler_markAsRead_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserNotificationsV2WebApiHandler_markAsRead_Args) =>
      RentalManagerUserNotificationsV2WebApiHandler_markAsRead(args.postData, httpClient),
  });
};

export interface RentalManagerUserNotificationsV2WebApiHandler_tracking_Args {
  postData: UserNotificationsTrackingV2RequestDto;
}

export type RentalManagerUserNotificationsV2WebApiHandler_tracking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserNotificationsV2WebApiHandler_tracking_Args
>;

/**
 * Track push notifications events
 */
export const useRentalManagerUserNotificationsV2WebApiHandler_tracking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserNotificationsV2WebApiHandler_tracking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserNotificationsV2WebApiHandler_tracking_Args) =>
      RentalManagerUserNotificationsV2WebApiHandler_tracking(args.postData, httpClient),
  });
};
